import { Card } from "react-bootstrap";

export default function FilmEdit() {
  const resources = [
    {
      title: "Create a test video",
      description: "Get feedback before filming your whole course",
      link: "#",
    },
    {
      title: "Teaching Center: Guide to quality A/V",
      description: "Film and edit with confidence",
      link: "#",
    },
    {
      title: "KaaS trust & safety",
      description:
        "Our policies for instructors and students",
      link: "#",
    },
  ];
  return (
    <div className="p-4">
      <h2 className="mb-4">Film & edit</h2>

      <div className="d-flex gap-5">
        <div className="flex-grow-1">
          <div className="mb-5">
            <h3 className="h4 mb-3">You're ready to share your knowledge.</h3>
            <p className="text-muted">
              This is your moment! If you've structured your course and used our guides, you're well prepared for the
              actual shoot. Pace yourself, take time to make it just right, and fine-tune when you edit.
            </p>
          </div>

          <div className="mb-5">
            <h3 className="h4 mb-4">Tips</h3>

            <div className="mb-4">
              <h4 className="h5 mb-2">Take breaks and review frequently.</h4>
              <p className="text-muted">
                Check often for any changes such as new noises. Be aware of your own energy levels—filming can tire you
                out and that translates to the screen.
              </p>
            </div>

            <div className="mb-4">
              <h4 className="h5 mb-2">Build rapport.</h4>
              <p className="text-muted">
                Students want to know who's teaching them. Even for a course that is mostly screencasts, film yourself
                for your introduction. Or go the extra mile and film yourself introducing each section!
              </p>
            </div>

            <div>
              <h4 className="h5 mb-2">Being on camera takes practice.</h4>
              <p className="text-muted">
                The more you practice, the more natural you'll feel. Try recording yourself a few times before filming
                the real thing.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">Set yourself up for editing success.</h4>
              <p className="text-muted">
              You can edit out long pauses, mistakes, and ums or ahs. Film a few extra activities or images that you can add in later to cover those cuts.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">Create audio marks.</h4>
              <p className="text-muted">
              Clap when you start each take to easily locate the audio spike during editing. Use our guides to manage your recording day efficiently.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">For screencasts, clean up.</h4>
              <p className="text-muted">
              Move unrelated files and folders off your desktop and open any tabs in advance. Make on-screen text at least 24pt and use zooming to highlight.
              </p>
            </div>
          </div>
          <div className="container mt-4">
            <h4 className="fw-bold">Requirements</h4>
            <ul className="list-unstyled">
              <li>🔹Film and export in HD to create videos of at least 720p, or 1080p if possible</li>
              <li>🔹 Audio should come out of both the left and right channels and be synced to your video</li>
              <li>🔹Audio should be free of echo and background noise so as not to be distracting to students</li>
            </ul>
          </div>
          <div className="container mt-4">
            <h4 className="fw-bold">Resources</h4>
            {resources.map((resource, index) => (
              <div key={index} className="mb-3">
                <a
                  href={resource.link}
                  className="text-primary fw-bold text-decoration-underline"
                >
                  {resource.title}
                </a>
                <p className="m-0">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>

        <Card className="bg-white shadow-sm" style={{ maxWidth: "300px" }}>
          <Card.Body className="text-center">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-frDxPt9KnVNVAXul6jcDt0Jw8zRxvn.png"
              alt="Video camera illustration"
              className="mb-3"
              style={{ width: "100px", height: "auto" }}
            />
            <h4 className="h5 mb-3">You're in good community</h4>
            <p className="text-muted mb-4">Chat and get production help with other Udemy instructors</p>
            <button className="btn btn-outline-primary">Join the community</button>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
